import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToastBarComponent} from "./toast-bar.component";

@NgModule({
    declarations: [ToastBarComponent],
    exports: [
        ToastBarComponent
    ],
    imports: [
        CommonModule
    ]
})
export class ToastBarModule {
}
